import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { TableColumn } from '@shared/interface/table.interface';
import { PageInfoService } from '@metronic/layout';
import { BaseDatasource } from '@shared/base/base.datasource';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor(
    private pageInfoService: PageInfoService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {}

  // For filter Search
  onSearch(event: string) {
    const snapshot = this.activeRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };
    if (event) {
      delete dataParam.page;
      this.router
        .navigate([], {
          queryParams: {
            ...dataParam,
            string_filter: '' || event,
          },
        })
        .then(() => null);
    } else {
      delete dataParam.string_filter;
      this.router.navigate([], { queryParams: dataParam }).then(() => null);
      // this.string_filter = '';
    }
  }

  // For Reset Filter
  resetFilter(filterForm: FormGroup, keyFilter: string[]) {
    if (!filterForm && keyFilter) return;
    const dataParam = { ...this.activeRoute.snapshot?.queryParams };
    keyFilter.map((_key) => {
      filterForm.controls[_key].setValue('');
      delete dataParam[_key];
    });
    return this.router?.navigate([], { queryParams: dataParam }).then(() => null);
  }

  // Handle Submitted Filter
  submitFilter(filterForm: FormGroup, extras: any | null = null) {
    if (!filterForm.value) this.router.navigate([]).then(() => null);
    const dataParam = { ...this.activeRoute.snapshot.queryParams };
    delete dataParam.page;

    Object.entries(filterForm.value).forEach(([key, v]) => {
      if (v === null || v === '') delete dataParam[key];
    });

    const cleanFormValue = Object.fromEntries(Object.entries(filterForm.value).filter(([, v]) => v !== null && v !== ''));

    const baseQueryParams = { ...dataParam, ...cleanFormValue };

    const mergedQueryParams = extras?.queryParams ? this.manageDataParam(extras.queryParams, baseQueryParams) : baseQueryParams;

    let _extras: object = { queryParams: mergedQueryParams };

    if (extras) {
      const restExtras = Object.fromEntries(Object.entries(extras).filter(([key]) => key !== 'queryParams'));
      _extras = { ..._extras, ...restExtras };
    }

    this.router.navigate([], _extras).then(() => null);
  }

  // Sort Table
  sortTable(param: Sort, tableColumns: TableColumn[]) {
    if (!param.direction) {
      return this.removeQueryParamSort();
    }

    const sortby = tableColumns.find((column) => column.key === param.active);
    const activeKey = sortby?.key ?? '';

    return this.sortDataSource({ ...param, active: activeKey });
  }

  sortDataSource(sortParams: Sort) {
    const dataParam: IQueryParams = {
      sort: sortParams.active + ',' + sortParams.direction,
    };

    return this.sortNavigate(dataParam);
  }

  filterCountList(baseDataSource: any, title: string) {
    baseDataSource.totalItem$.subscribe((data: any) => {
      if (data) {
        this.pageInfoService.updateTitle(`${title} ( ${data} )`);
      } else {
        this.pageInfoService.updateTitle(`${title} (0)`);
      }
    });
  }

  changePageEvent($event: BaseDatasource<any>, string_filter: string, state?: any) {
    const { pageSize, current_page } = $event;
    const dataParam: IQueryParams = {
      page: current_page,
      size: pageSize,
    };

    if (string_filter) {
      dataParam.string_filter = string_filter;
    }

    const _extras = <NavigationExtras>{
      queryParams: { ...dataParam },
      queryParamsHandling: 'merge',
    };

    if (state) {
      _extras.state = state;
    }

    this.router.navigate([], _extras).then(() => null);
  }

  validateSubmitFilter(form: FormGroup) {
    const _val = form.value;
    let hasValue = false;
    for (const key in _val) {
      if (_val[key] && !Array.isArray(_val[key])) {
        hasValue = true;
        break;
      } else if (Array.isArray(_val[key]) && _val[key].length) {
        hasValue = true;
        break;
      }
    }
    return !hasValue;
  }

  private removeQueryParamSort() {
    const snapshot = this.activeRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };
    delete dataParam.sort;
    return this.sortNavigate(dataParam);
  }

  private sortNavigate(dataParam: IQueryParams) {
    const dataParamIsEmpty = !Object.keys(dataParam).length;
    return this.router.navigate([], {
      relativeTo: this.activeRoute,
      queryParams: dataParam,
      queryParamsHandling: dataParamIsEmpty ? '' : 'merge',
    });
  }

  // Private Functions Filter Service
  private manageDataParam(queryParams: any, dataParam: any) {
    if (!queryParams) return;

    const extras: any = {
      ...dataParam,
    };

    Object.keys(queryParams).map((key) => {
      extras[key] = queryParams[key];
    });

    return extras;
  }
}
